module.exports = "<router-outlet (activate)=\"fetchurl()\"></router-outlet>\n<app-loader></app-loader>\n<agm-map [latitude]=\"lat\" [longitude]=\"lng\" (mapClick)=\"getAddress($event)\">\n    <agm-marker [latitude]=\"lat\" [longitude]=\"lng\"></agm-marker>\n</agm-map>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src185846418/src/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main